/** COOKIES */
const PAYMENT_TOAST_SHOWED_EXPIRED_CARD_COOKIE_NAME = 'paymentToastExpiredCardShowed';
const PAYMENT_TOAST_SHOWED_GRACE_PERIOD_COOKIE_NAME = 'paymentToastGracePeriodShowed';
const PAYMENT_TOAST_SHOWED_SHOPPING_CART_COOKIE_NAME = 'paymentToastShoppingCartShowed';

/** DATE **/
const MILLISECONDS_IN_A_DAY = 1000 * 60 * 60 * 24;

export {
  PAYMENT_TOAST_SHOWED_EXPIRED_CARD_COOKIE_NAME,
  PAYMENT_TOAST_SHOWED_GRACE_PERIOD_COOKIE_NAME,
  PAYMENT_TOAST_SHOWED_SHOPPING_CART_COOKIE_NAME,
  MILLISECONDS_IN_A_DAY,
};
